import UltMeta, { Meta } from "./UltMeta";

/**
 * 费用类型
 */
class RateType extends UltMeta {
    DEPOSIT = new Meta(1, "一年期");
}
export const RATETYPE = new RateType();
